import { Component, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { addedIntervenant, associatedIntervenant1, emailExist, personalEmailExist, phoneNumberExist, existedIntervenant, existedManager, associatedIntervenant, associatedIntervenant2, updatedIntervenant, serverError, CraWorkflowLinkedRole } from '@core/models/messages';
import { patternfirstName, patternEmail, linkedInRegExp } from '@core/models/pattern';
import { CompanyService } from '@core/services/company/company.service';
import { IntervenantSelectedService } from '@core/services/company/intervenant-selected.service';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PrimeNGConfig } from 'primeng/api';
import { Subject, debounceTime, distinctUntilChanged, switchMap, catchError, takeUntil } from 'rxjs';

@Component({
  selector: 'app-update-intervenant',
  templateUrl: './update-intervenant.component.html',
  styleUrls: ['./update-intervenant.component.css']
})
export class UpdateIntervenantComponentNew {
intervenantForm: FormGroup = this.createIntervenantForm();
phoneForm: FormGroup = this.createFormPhone();
private searchTerms = new Subject<string>();
cvname: any;
file: any = '';
isPhoneNumberValid: boolean = false;
validPhoneNumber: boolean = false;
isexistemail: boolean = false;
isPhoneEnabled: boolean = true;
iscv: boolean = false
separateDialCode: boolean = false;
idUser!: any;
private unsubscribeAll: Subject<void> = new Subject();
listRole: { id: number; name: string }[] = [];
fileExtention: string = '';
fileError: string = '';
fileName: string = '';
 SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.UnitedKingdom,
  ];
  PhoneNumberFormat = PhoneNumberFormat;
  selectedIntervenant: any;
  idIntervenant: any;
  isUpdatedCV: boolean = false;
constructor(
  private companyService: CompanyService,
   private router: Router,
  private formBuilder: FormBuilder,
  private spinner: NgxSpinnerService,
  private toastr: ToastrService,
  private elRef: ElementRef,
  private intervenantSelectedService : IntervenantSelectedService,
  private primengConfig: PrimeNGConfig,
) { 
  this.primengConfig.setTranslation({
            dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
            dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
            dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
            monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
            monthNamesShort: ["Jan", "Fév", "Mar", "Avr", "Mai", "Juin", "Juil", "Aoû", "Sep", "Oct", "Nov", "Déc"],
            today: 'Aujourd\'hui',
            clear: 'Effacer'
          });
}

ngOnInit(): void {

  if (this.intervenantSelectedService.hasIntervenantSelected()) {
        this.selectedIntervenant = this.intervenantSelectedService.getIntervenantSelected()
        this.initializeIntervenantForm()
      }
      else{
        this.router.navigateByUrl('/intervenants');
      }  

  this.searchTerms
          .pipe(
            debounceTime(300),
            distinctUntilChanged(),
            switchMap((searchName) => {
            const data = {
              email: searchName,
            };
  
              return this.companyService
              .getintervenant(data).pipe(
                catchError(() => {
                  this.intervenantForm.patchValue({
                    first_name: '',
                    last_name: '',
                    linkedin_link: '',
                    cvname: '',
                  });
                  this.cvname = '';
                  this.isexistemail = false;
                  this.iscv = false;
                  return [];
                })
              );
            })
          )
          .subscribe((res: any) => {
            if (res.data.length == 0) {
              this.intervenantForm.patchValue({
                first_name: '',
                last_name: '',
                linkedin_link: '',
                cvname: '',
              });
              this.cvname = '';
              this.phoneForm.controls['phone'].disable();
              this.phoneForm.controls['phone'].setValue('');
              this.isexistemail = false;
              this.iscv = false;
            } else {
              this.isexistemail = true;
              if (res.data[0].cv && res.data[0].cv !== 'null') {
                this.iscv = true;
                this.cvname = res.data[0].cv;
              } else {
                this.iscv = false;
              }
  
              this.intervenantForm.patchValue({
                first_name: res.data[0].first_name,
                last_name: res.data[0].last_name,
                linkedin_link: res.data[0].linkedin_link,
                cvname: res.data[0].cv,
                phone_number: res.data[0].phone_number,
                emailProESN: res.data[0].emailProESN,
                emailProClient: res.data[0].emailProClient,
              });
  
              const phoneNumber = res.data[0].phone_number || '';
              this.phoneForm.controls['phone'].setValue(phoneNumber);
  
              if (!phoneNumber) {
                // Désactiver le placeholder lorsque le numéro est vide
                this.separateDialCode = false;
                this.phoneForm.controls['phone'].setValue('');
                this.phoneForm.controls['phone'].disable();
              } else {
                this.phoneForm.controls['phone'].disable();
              }
  
              this.idUser = res.data[0].uuid;
              this.cvname = res.data[0].cv;
  
              if (res.data.cv) {
                this.file = { name: res.data.cv };
              }
            }
          });
  this.phoneForm.controls['phone'].disable();

    // Ensure the input and country selector remain disabled
  this.preventCountryChange();

    // Handle existing email logic to toggle the phone input field
  this.checkEmailExistsAndTogglePhone();
  this.getListRole();
  this.intervenantForm.get('linkedin_link')?.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        this.setValidatorRequirements();
      });

  this.intervenantForm.get('cv')?.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe(() => {
        this.setValidatorRequirements();
      });

    // Appelez la méthode une fois pour initialiser les validateurs
    this.setValidatorRequirements();
  
}

createFormPhone(data?: any) {
  return this.formBuilder.group({
    phone: [data && data.phone],
  });
}

getRoleName(employeeRoleId: number): string {
    const role = this.listRole.find((role) => role.id === employeeRoleId);
    return role ? role.name : 'Role not found';
  }
  createIntervenantForm(data?: any) {        
    return this.formBuilder.group({
      first_name: [
        data && data.first_name,
        [Validators.required, Validators.pattern(patternfirstName)],
      ],
      last_name: [
        data && data.last_name,
        [Validators.required, Validators.pattern(patternfirstName)],
      ],
      emailProESN: [
        data && data.emailProESN,
        [Validators.pattern(patternEmail)],
      ],
      emailProClient: [
        data && data.emailProClient,
        [Validators.pattern(patternEmail)],
      ],
      email: [
        data && data.email,
        [Validators.required, Validators.pattern(patternEmail)],
      ],
      linkedin_link: [data && data.linkedin_link ? data.linkedin_link : ''],
      date_signature: [data && data.date_signature ? new Date(data.date_signature) : null],
      phone_number: [
        data && data.phone_number ? data.phone_number : '',
        [Validators.required],
      ],
      cv: [data && data.cv ? data.cv : ''],
      employee_role_id: [
        data && data.employee_role_id ? data.employee_role_id : null,
        [Validators.required],
      ],
      employee_id: [''],
    });
  }

  getListRole() {
    this.companyService
      .getListRoleByCompany()
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          this.listRole = res.data?.filter((role: { name: string; }) => role.name !== "admin");;
        },
        error: () => { },
      });
  }
  onPhoneChange(event: any): void {
    // Suppose the event contains the phone number object from ngx-intl-tel-input
    if (event) {
      const phoneControl = this.phoneForm.get('phone');
      if (phoneControl) {
        phoneControl.setValue(event); // Update the form control value

        // If you need to update another form control based on phone number change
        const phoneNumber = event.internationalNumber; // Or however the event structure is
        this.intervenantForm.get('phone_number')?.setValue(phoneNumber);

        // Perform any additional actions you need when the phone number changes
        this.validPhoneNumber = phoneControl.valid; // Update the validity state
      }
    }
  }


    updateIntervenant() {
      this.phoneForm.controls['phone'].disable();
      this.phoneForm.get('phone')?.disable();
      this.intervenantForm.get('employee_id')?.setValue(this.idIntervenant);
      const phone = this.phoneForm.get('phone')?.value;
      this.intervenantForm
        .get('phone_number')
        ?.setValue(phone?.internationalNumber);
        const updatePayload = { ...this.intervenantForm.value };
        delete updatePayload.first_name;
        delete updatePayload.last_name;
        delete updatePayload.email;
        delete updatePayload.phone_number;
  
      if(this.file){
        updatePayload.cv = this.file
      } else{
         delete updatePayload.cv;
      }
      delete updatePayload.phone_number;
      this.spinner.show();
  
      const formData = new FormData();
      Object.entries(updatePayload).forEach(([key, value]) => {
      if (key === 'cv' && value instanceof Blob) {
        formData.append(key, value);
      } else {
        formData.append(key, String(value ?? ''));
      }
      })
  
      this.companyService
        .updateIntervenant(formData)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            this.toastr.success(updatedIntervenant);
            this.intervenantForm.reset();
            this.router.navigateByUrl('/intervenants');
          },
          error: (err) => {
            this.spinner.hide();
            let errorMessage = '';
            
            if (err?.error?.message) {
              const emailErrorMessage = err.error.message.email;
  
              if (
                emailErrorMessage &&
                emailErrorMessage[0] === 'The email has already been taken.'
              ) {
                errorMessage = associatedIntervenant1;
              } else if (err.error.message['emailProESN']) {
                errorMessage = emailExist;
              } else if (err.error.message['email']) {
                errorMessage = personalEmailExist;
              } else if (err.error.message['phone_number']) {
                errorMessage = phoneNumberExist;
              } else if (err.error.message['name']) {
                errorMessage = existedIntervenant;
              } else if (
                err.error.message.includes('Company already has a responsable')
              ) {
                errorMessage = existedManager;
              } else if (
                err.error.message.includes(
                  'employee already associated to another company.'
                )
              ) {
                errorMessage = associatedIntervenant;
              } else if (
                err.error.message.includes(
                  'employee already associated to this company.'
                )
              ) {
                errorMessage = associatedIntervenant2;
              }
              else if (err?.error && err.status===400 && err?.error?.message &&
                err?.error?.message === 'This role has SubWorkflowCras and cannot be updated.'
              ) {
                 const errorMessage = '"Ce rôle est lié à des workflows actifs et ne peut pas être modifié"';
                this.toastr.error(errorMessage);
              } else if (
                err.error.message.includes(
                  'This role has Workflow Cras and cannot be updated.'
                )
              ) {
                errorMessage = CraWorkflowLinkedRole;
              } else{
                errorMessage = serverError
              }
              if (errorMessage) {
                this.toastr.error(errorMessage);
              }
            }
          },
        });
    }
  

  onSearch(event: any): void {
    const term = event.target.value.trim();
    this.searchTerms.next(term); // Emit the current search term
  }

  setValidatorRequirements() {
      const linkedinControl = this.intervenantForm.get('linkedin_link');
      const cvControl = this.intervenantForm.get('cv');
  
      // Effacer les validateurs existants
      linkedinControl?.clearValidators();
      cvControl?.clearValidators();
  
      if (!linkedinControl?.value && !cvControl?.value) {
        linkedinControl?.setValidators([
          Validators.pattern(linkedInRegExp),
        ]);
      } else {
        if (linkedinControl?.value) {
          linkedinControl?.setValidators([Validators.pattern(linkedInRegExp)]);
        }
        if (cvControl?.value) {
          cvControl?.clearValidators();
        }
      }
  
      linkedinControl?.updateValueAndValidity({ emitEvent: false });
      cvControl?.updateValueAndValidity({ emitEvent: false });
    }

    resetCV() {
      const inputFile = document.getElementById('cv') as HTMLInputElement;
      if (inputFile) {
        inputFile.value = '';
  
        this.fileExtention = '';
        this.fileError = '';
      }
      this.fileName = '';
      this.cvname = ''
      this.isUpdatedCV = true
    }

    uploadFile(event: any) {
      this.file = event.target.files[0];
      const maxSize = 2 * 1024 * 1024;
      this.fileName = this.file.name;
      if (this.file) {
        const allowedExtensions = ['.pdf', '.docx', '.doc'];
        const fileExtension = this.file.name
          .toLowerCase()
          .substr(this.file.name.lastIndexOf('.'));
  
        if (!allowedExtensions.includes(fileExtension)) {
          this.fileExtention = 'Format fichier non compatible !';
        } else if (this.file.size > maxSize) {
          this.fileError = 'Le fichier à importer ne doit pas depasser 2 méga !';
        } else {
          this.fileError = '';
          this.fileExtention = '';
        }
        this.isUpdatedCV = true
        //this.iscv = true;
      }
      this.intervenantForm.get('cv')?.setValue(this.file);
    }

    isFileNameCompatible(): boolean {
      if (!this.file) {
        return false; // Aucun fichier sélectionné
      }
  
      const allowedExtensions = ['.pdf', '.docx', '.doc'];
      const fileExtension = this.file.name
        .toLowerCase()
        .substr(this.file.name.lastIndexOf('.'));
      return allowedExtensions.includes(fileExtension);
    }

    disableEvent(event: Event) {
      event.preventDefault();
      event.stopPropagation();
    }

    preventCountryChange() {
      const phoneInput = this.phoneForm.get('phone');
      if (phoneInput) {
          // Add event listeners to block interaction
          const phoneInputElement = this.elRef.nativeElement.querySelector('.ngx-intl-tel-input');
          if (phoneInputElement) {
              phoneInputElement.addEventListener('mousedown', this.disableEvent);
              phoneInputElement.addEventListener('keydown', this.disableEvent);
              phoneInputElement.addEventListener('countryChange', this.preventCountryChange);
          }
      }
    }
    allowCountryChange() {
      const phoneInputElement = this.elRef.nativeElement.querySelector('.ngx-intl-tel-input');
      if (phoneInputElement) {
          phoneInputElement.removeEventListener('mousedown', this.disableEvent);
          phoneInputElement.removeEventListener('keydown', this.disableEvent);
          phoneInputElement.removeEventListener('countryChange', this.preventCountryChange);
      }
    }

    checkEmailExistsAndTogglePhone() {
      if (this.isexistemail) {
          this.phoneForm.controls['phone'].disable(); // Disable if email exists
          this.preventCountryChange();
      } else {
          this.phoneForm.controls['phone'].disable(); // Enable otherwise
          this.allowCountryChange();
      }
      this.phoneForm.controls['phone'].updateValueAndValidity();
  }

     initializeIntervenantForm() {
      this.idIntervenant = this.selectedIntervenant?.uuid;
      this.intervenantForm = this.createIntervenantForm(this.selectedIntervenant);
      this.phoneForm.get('phone')?.setValue(this.selectedIntervenant?.phone_number);
      const phone = this.phoneForm.get('phone')?.value;
      this.intervenantForm
        .get('phone_number')
        ?.setValue(phone?.internationalNumber);
      this.intervenantForm.get('cv')?.setValue(this.selectedIntervenant?.cv);      
      if(this.selectedIntervenant?.cv && this.selectedIntervenant?.cv !== 'null') {
        this.cvname = this.selectedIntervenant?.cv;
      }

      this.phoneForm.controls['phone'].disable();

      }
}
